import React from 'react';
import styled from 'styled-components';

import img1 from "../../Assets/images/nfts/nft1.svg"
import img2 from "../../Assets/images/nfts/nft2.svg"
import img3 from "../../Assets/images/nfts/nft3.svg"
import img4 from "../../Assets/images/nfts/nft4.svg"

const Section = styled.section`
    min-height: 100vh;
    width: 100%;
    background-color: ${props => props.theme.body};
    position: relative;
`

const Title = styled.h1`
    font-size: ${(props) => props.theme.fontxxl};
    text-transform: uppercase;
    color: ${(props) => props.theme.text};
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem auto;
    width: fit-content;
`

const Container = styled.div`
    width: 95%;
    margin: 2rem auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    @media (max-width: 35em) {
        width: 50%;
        text-align: center;
    }
`

const Item = styled.div`
    width: calc(38rem - 4vw);
    padding: 1rem 0;
    color: ${props => props.theme.body};
    margin: 2rem 1rem;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    @media (max-width: 78em) {
        flex-direction: column;
        width: calc(23rem - 4vw);
    }

    @media (max-width: 48em) {
        flex-direction: row;
        width: calc(38rem - 4vw);

    }

    @media (max-width: 35em) {
        flex-direction: column;
        width: calc(23rem - 4vw);
    }
    
`

const ImageContainer = styled.div`
    width: 17rem;
    background-color: ${props => props.theme.body};
    border-radius: 20px;
    cursor: pointer;
    border: 3px solid black;
    padding: 1rem;
    
    img {
        width: 100%;
        height: auto;
    }
`

const TextWrapper = styled.div`
    margin: 0 1rem;
    color: ${props => props.theme.text};
    width: 17rem;
    height: 5rem;
`

const Member = styled.h1`
    font-size: ${(props) => props.theme.fontxl};
    margin: 1rem 0;    
`

const Skills = styled.h1`
    font-size: ${(props) => props.theme.fontmd};
    color: ${(props) => `rgba(${props.theme.textRgba}, 0.6)`};
    font-weight: 400;
`

const Collage = ({img, member, skills}) => {
    return (
        <Item>
            <ImageContainer>
                <img src={img} alt='member'></img>
            </ImageContainer>
            <TextWrapper>
                <Member>{member}</Member>
                <Skills>{skills}</Skills>
            </TextWrapper>
        </Item>
    )
}

const Team = () => {
    return (
        <Section id="team">
            <Title>Team</Title>
            <Container>
                <Collage img={img1} member="JollyShow" skills="Founder of JollyShow. Artist/Animator"></Collage>
                <Collage img={img2} member="Moses" skills="Co-founder of JollyShow. Web Developer"></Collage>
                <Collage img={img3} member="Sunny" skills="Digital Marketer for JollyShow NFT"></Collage>
                <Collage img={img4} member="Abraham" skills="Web developer for JollyShow NFT"></Collage>
            </Container>
        </Section>
    )
}
export default Team;